/**
 * Small shared helpers (not tied to a specific API resource).
 */

/** Default host id when visiting `/` (from `.env`). */
export function getDefaultHostIdFromEnv() {
  return (
    process.env.REACT_APP_DEFAULT_HOST_ID ||
    process.env.REACT_APP_DEFAULT_CLUB_ID ||
    ""
  ).trim();
}

/** Copy the current page URL to the clipboard (share button). */
export async function copyCurrentPageUrlToClipboard() {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(window.location.href);
  }
}
